import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivitiesComponent } from 'app/home/search-box/categories/activities/activities.component';
import { HotelsComponent } from 'app/home/search-box/categories/hotels/hotels.component';
import { InsuranceComponent } from 'app/home/search-box/categories/insurance/insurance.component';
import { RentcarsComponent } from 'app/home/search-box/categories/rentcars/rentcars.component';
import { TransportsComponent } from 'app/home/search-box/categories/transports/transports.component';
import { MultiDestinationComponent } from 'app/multi-destination/multi-destination.component';
import { filter, take } from 'rxjs/operators';
import { TransportsService } from '../modals/modal-transports/transports.service';
import { HotelService } from '../modals/modal-hotel/hotel.service';
import { CategoryResultComponent } from 'app/content-result/category-result/category-result.component';
import CssFilterConverter from "css-filter-converter";
import { PACKAGES } from 'app/home/search-box/categories/packages/response/searchResponsepackages';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ResultsSearchService } from 'app/home/results-search.service';
import { RestService } from '../rest.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ModalLoadingComponent } from '../modal-loading/modal-loading.component';
import { NotFoundModalComponent } from '../modals/not-found-modal/not-found-modal.component';

@Component({
  selector: 'usb-navbar-search-categories',
  templateUrl: './navbar-search-categories.component.html',
  styleUrls: ['./navbar-search-categories.component.scss']
})
export class NavbarSearchCategoriesComponent implements OnInit, AfterViewInit {
  @Input() getClientsSettingAppBooking;
  @Input() _results
  @Input() qtyProductValid: number;
  @Output() emitterNewResults = new EventEmitter<any>();
  @ViewChild(CategoryResultComponent) categoryResult: CategoryResultComponent;
  @ViewChildren('categoryButton') buttons: QueryList<ElementRef>;
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;

  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  @Output() openModalResearchEmmit = new EventEmitter<any>();
  reloadSearching: boolean = false;
  _payload: any;
  _origin: any;
  _form: any;
  categoryId: number = 0;
  formTransports: any;
  styleSidebar: any;
  isLoading: boolean = false;
  bsModalRef?: BsModalRef;
  modalRef: BsModalRef;
  activeComingSoonIndex: number | null = null;
  private activeButtonIndex: number | null = null;
  private routerSubscription: any;
  private basePath: string | null = null;

      categories = [
      {id: 1, label: 'Alojamiento', icon: 'assets/img/app/categories-search-box/ima_hotel.svg'},
      {id: 2, label: 'Rent a car', icon: 'assets/img/app/categories-search-box/car-compact.svg'},
      {id: 6, label: 'Experiencia', icon: 'assets/img/app/categories-search-box/road-map.svg'},
      {id: 8, label: 'Traslado', icon: 'assets/img/app/categories-search-box/bus.svg'},
      // {label: 'Multidestino', icon: 'assets/img/app/categories-search-box/worldwide.svg'},
      {id: 9, label: 'Tickets', icon: 'assets/img/app/categories-search-box/combi-ticket.svg'},
      {id: 4, label: 'Paquetes', icon: 'assets/img/app/categories-search-box/maleta.svg'},
      {id: 10, label: 'Asistencia', icon: 'assets/img/app/categories-search-box/icon-seguro.svg'}

  ]

  constructor(
        private modalService: BsModalService,
        private resultsSearch: ResultsSearchService,
        private _restService: RestService,
        private _router: Router,
        private dialog: MatDialog,
        private transportsService: TransportsService,
        private hotelService: HotelService,
         private activatedRoute: ActivatedRoute,
        private renderer: Renderer2) { }

  ngOnInit(): void {

    this._payload = JSON.parse(localStorage.getItem('payload'));
    this._origin = localStorage.getItem('origin');
    if(this._payload) {
      this.categoryId =  this._payload[0]?.categoriesId[0];
    }
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);

        // 1. Capturar la ruta inicial inmediatamente
    this.captureInitialRoute();

    // 2. Suscribirse a futuros cambios
    this.subscribeRouteChanges();
  }

  ngAfterViewInit(): void {
      if(this._payload) {
        this.activeButtonIndex = this._payload[0]?.categoriesId[0];
      }
        this.setupButtonInteractions();
        this.buttonActiveResearch();
  }


/**
 * Captura la ruta inicial al cargar el componente
 */
private captureInitialRoute(): void {
    const currentUrl = this._router.url;

    // Extraer solo la parte principal de la ruta (sin query params)
    this.basePath = this.extractBasePath(currentUrl);


}



/**
 * Suscribe a cambios de ruta
 */
private subscribeRouteChanges(): void {
    this.routerSubscription = this._router.events
        .pipe(
            filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
            const currentUrl = this._router.url;

            // Extraer y guardar la ruta base
            this.basePath = this.extractBasePath(currentUrl);

            // Si necesitas los parámetros también
            const snapshot = this.activatedRoute.snapshot;
            const queryParams = snapshot.queryParams;

        });
}

/**
 * Extrae solo la parte base de la ruta (sin query params)
 * Ej: /itinerary-detail?id=36&stat=false → /itinerary-detail
 */
private extractBasePath(fullPath: string): string {
    // Eliminar query params y fragmentos
    const pathWithoutQuery = fullPath.split('?')[0].split('#')[0];

    // Obtener el primer segmento después del /
    const segments = pathWithoutQuery.split('/').filter(segment => segment);

    if (segments.length > 0) {
        return '/' + segments[0];
    }

    return '/'; // Ruta raíz
}

/**
 * Extrae solo el nombre de la ruta sin el /
 * Ej: /itinerary-detail → itinerary-detail
 */
private extractRouteName(fullPath: string): string {
    const basePath = this.extractBasePath(fullPath);
    return basePath.replace('/', '');
}


  openFormSearch(modalSearch: string): void {
    this.openModalResearchEmmit.emit(true);
    let dialogRef: any;
    const payload = JSON.parse(localStorage.getItem('payload'));
    const form = JSON.parse(localStorage.getItem('form'));
    switch (modalSearch) {
      case 'Alojamiento':
          localStorage.setItem('origin', 'HOTELS')
          dialogRef = this.dialog.open(HotelsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 1,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para hotel


        break;

      case 'Rent a car':
        dialogRef = this.dialog.open(RentcarsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          panelClass: 'rentcar-dialog',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 2,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para rent a car
        break;

      case 'Experiencia':
         dialogRef = this.dialog.open(ActivitiesComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 6,
                  idActivity: 6,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para tours
        break;

      case 'Traslado':
          dialogRef = this.dialog.open(TransportsComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {
                  clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 8,
                  payload: payload,
                  formTransport: form
                }
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para traslado

        break;

      case 'Multidestino':
         this.dialog.open(MultiDestinationComponent, {
          width: '85%',
          height: 'auto',
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para multidestino
        break;

      case 'Tickets':
        dialogRef = this.dialog.open(ActivitiesComponent, {
          width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {clientSetting: this.getClientsSettingAppBooking,
                  component: 'results',
                  category: 9,
                  idActivity: 9,
                  payload: payload,
                  form: form}
          // data: { option: 'hoteles' } // lo que necesites pasar
        });
        // lógica para tours
        break;



      case 'Paquetes':
        // this.dialog.open(PackagesComponent, {
        //   width: '85%',
        //   height: 'auto',
        //   // data: { option: 'hoteles' } // lo que necesites pasar
        // });
        // lógica para paquetes
        break;

      case 'Asistencia':
         dialogRef = this.dialog.open(InsuranceComponent, {
            width: '85%',
          height: 'auto',
          minHeight: '320px',
          data: {
                    clientSetting: this.getClientsSettingAppBooking,
                    component: 'results',
                    category: 10,
                    payload: payload,
                    form: form // lo que necesites pasar
        }
        });
        // lógica para asistencia
        break;

      default:
        console.warn('Categoría no reconocida:', modalSearch);
        break;
    }

    if(dialogRef) {
      dialogRef.afterClosed().pipe(
        take(1)
        ).subscribe((payload) => {
          if(payload) {
            this.reloadSearching = true;
            this._payload = JSON.parse(localStorage.getItem('payload'));
            this._origin = localStorage.getItem('origin');
            this.categoryId = this._payload[0].categoriesId[0];
            if(this.categoryId === 1) {
              this._form = JSON.parse(localStorage.getItem('form'));
              this.getQtyProductValid();
              this.hotelService.initializeSelection(this._form);
            }
            if(this.categoryId === 8) {
              this.formTransports = JSON.parse(localStorage.getItem('form'));
              this.transportsService.initializeAssignment(this._payload[0].transfers.paxList);
            }
              this.buttons?.forEach((button: ElementRef, index: number) => {
              this.renderer.setStyle(button.nativeElement, 'color', 'none');
            });
            this.buttonActiveResearch();
            this.loadResult(this._payload[0].categoriesId[0], [payload]);


            if(this._results && this._results.length > 0) {
              this.openModalResearchEmmit.emit(false);
              this.categoryResult.researchPaxList(payload, false, false);
            }

            // this._results = this.resultsSearch._getResponse();
          } else {
            return;
          }
        })
    }
  }

      getQtyProductValid(): void {
    switch(this._payload[0].categoriesId[0]) {
      case 1:
        this.qtyProductValid = this._payload[0].qtyProduct;
        break;
    }
  }

  buttonActiveResearch(): void {
  if (!this._payload || !this._payload[0]?.categoriesId?.length) return;

  const categoryIdFromPayload = this._payload[0].categoriesId[0];
  const buttonIndex = this.categories.findIndex(cat => cat.id === categoryIdFromPayload);

  // Resetear todos los botones
  this.buttons?.forEach((button: ElementRef, index: number) => {
    const isComingSoon = this.activeComingSoonIndex === index;
    this.renderer.setStyle(
      button.nativeElement,
      'color',
      isComingSoon ? this.styleSidebar?.background_color_header : this.styleSidebar?.color
    );
    this.applyImageFilter(false, index, isComingSoon);
  });

  // Activar el nuevo botón si se encuentra y no es "Próximamente"
  if (buttonIndex !== -1 && this.buttons?.length > buttonIndex &&
      this.activeComingSoonIndex !== buttonIndex) {
    this.activeButtonIndex = buttonIndex;
    const button = this.buttons.toArray()[buttonIndex];
    this.renderer.setStyle(
      button.nativeElement,
      'color',
      this.styleSidebar?.background_color_header
    );
    this.applyImageFilter(true, buttonIndex);
  } else {
    this.activeButtonIndex = null;
  }
}

applyImageFilter(isActive: boolean, buttonIndex: number, isHovered: boolean = false) {
  const iconElement = this.icons.toArray()[buttonIndex]?.nativeElement;
  if (!iconElement) return;

  // Determinar si es un botón "Próximamente"
  const isComingSoon = this.activeComingSoonIndex === buttonIndex;

  if (isActive && !isComingSoon) {
    // Icono activo (excepto Próximamente)
    const activeColor = this.styleSidebar?.background_color_header;
    const activeFilter = this.getColorFilter(activeColor);
    iconElement.style.filter = activeFilter;
    iconElement.style.color = activeColor;
  } else if (isHovered || isComingSoon) {
    // Efecto hover o Próximamente (tratados igual)
    const hoverColor = isComingSoon ? this.styleSidebar?.color : this.styleSidebar?.background_color_header;
    const hoverFilter = this.getColorFilter(hoverColor);
    iconElement.style.filter = hoverFilter;
    iconElement.style.color = hoverColor;
  } else {
    // Icono inactivo
    const inactiveColor = this.styleSidebar?.color;
    const inactiveFilter = this.getColorFilter(inactiveColor);
    iconElement.style.filter = inactiveFilter;
    iconElement.style.color = inactiveColor;
  }
}

private getColorFilter(hexColor: string): string {
  if (!hexColor) return 'none';

  try {
    const tempFilterObj = CssFilterConverter.hexToFilter(hexColor, { sheen: false });
    const tempFilterStr = Object.keys(tempFilterObj)
      .map(key => `${key}(${tempFilterObj[key]})`)
      .join(" ");

    const colorMatch = tempFilterStr.match(/color\((.*)\)/);
    return colorMatch ? colorMatch[1] : "none";
  } catch (e) {
    console.error('Error converting color to filter:', e);
    return 'none';
  }
}


/**
 * Método para realizar una búsqueda en el endpoint.
 *
 * Este método gestiona la carga de resultados al realizar una solicitud al servidor.
 * Si la categoría en el payload es '7', se carga un paquete temporal. Si no, realiza
 * una solicitud HTTP POST con el payload para obtener los resultados. En ambos casos,
 * los resultados se almacenan en `_results`.
 *
 * Además, maneja el estado de carga mostrando un modal mientras se realiza la búsqueda,
 * y muestra mensajes de error en caso de no encontrar resultados o si ocurre un error en la solicitud.
 *
 * @category -> nombre de la categoría para la cual se están buscando resultados (como 'HOTELS', 'TOURS', etc.).
 * @payload -> un array de objetos con los parámetros de búsqueda que serán enviados en la solicitud.
 */
async loadResult(category: number, payload: any[]) {
  this.isLoading = true;

  if  ((this.isLoading)) {
      this.openModalLoading(JSON.parse(localStorage.getItem('payload')));
  }

  const categoryName = this.getCategoryName(category);

  if (payload[0].categoriesId[0] == '7') {  // temporal 12/10/2020
    // Cargar paquete temporal
    this._results[0] = PACKAGES;
    this._results[0].qtyPax = payload[0].qtyPax;
    this._results[0].others = payload[0].others;
    this._results[0].destination = payload[0].destination;
    this._results[0].payload = payload[0];
    this._results[0].categoryName = categoryName;
  } else { // fin temporal
    if (payload !== undefined && payload.length > 0) {
      this.resultsSearch._setPayload(payload);
      this._results = [];
      this._restService.doPost('app', 'search', payload[0]).subscribe({
        next: (response: any) => {
          // console.log('response search', response);
          // console.log('payload', this._payload[0]);
          if(Array.isArray(response)){
            const initialState: ModalOptions = {
              initialState: {
                message: '',
                confirmText: 'Cerrar',
                cancelText: 'Volver a intentar',
                showCancelButton: true,
                size: 'lg',
              }
            };

            const modalOptions = Object.assign({}, initialState, this.config);
            this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
            this.bsModalRef.content.confirmResult.subscribe((result:boolean) => {
              if(result){
                this.dialog.closeAll();
                this.reloadEditPencilEmitter();
              } else {

                if(this.basePath !== '/summary' && this.basePath !== '/item-detail') {
                  this._router.navigate(["/home"]);

                }



                this.dialog.closeAll();
              }
            })
          } else if (response !== null &&  Array.isArray(response.results) && response.results.length > 0) {

            this._results[0] = response.results;
            this._results[0].qtyPax = payload[0].qtyPax;
            this._results[0].others = payload[0].others;
            this._results[0].destination = payload[0].destination;
            this._results[0].arrivalDate = payload[0].arrivalDate;
            this._results[0].payload = payload[0];
            this._results[0].categoryName = category;
            this.isLoading = false;
            const origin = categoryName;
            this.resultsSearch._setOrigin(origin);
            this.resultsSearch._setResponse(this._results);
            // this.resultsSearch._setPayload(payload);
            this._setSearchIdInResults(response);
            if(category == 2){
              this.setArrivalAndDeparture(response, payload);
            }

            if(this.basePath !== '/results') {
              this._router.navigate(["/results"]);
            } else {
              this.emitterNewResults.emit();
            }
            this.dialog.closeAll();
            // if(category === '') {
            //   this.reloadSearching = false;
            // }
          } else {
            const initialState: ModalOptions = {
              initialState: {
                message: '',
                confirmText: 'Cerrar',
                cancelText: 'Volver a intentar',
                showCancelButton: true,
              }
            };

            const modalOptions = Object.assign({}, initialState, this.config);
            this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);

            this.bsModalRef.content.confirmResult.subscribe((result) => {
              if(result) {
                this.loadResult(category, payload);
              } else {
                this._router.navigateByUrl('/home');
              }
            });
          }
        },
        error: (error: HttpErrorResponse ) => {
          console.log(error)
          const initialState: ModalOptions = {
            initialState: {
              title: 'Error',
              message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo',
              confirmText: 'Reintentar',
              cancelText: 'Cancelar',
              showCancelButton: true,
              size: 'lg'
            }
          };

          this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
          const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
            if(result) {
              if (result) {
                this.loadResult(category, payload);
              } else {
                this.modalRef.hide();

                if(this.basePath !== '/summary' && this.basePath !== '/item-detail') {
                  this._router.navigate(["/home"]);

                }

              }
            }
            confirmSubscription.unsubscribe();
          });
        }
      });
    }
  }
}

getCategoryName(categoryId: number): string {

  switch(categoryId) {
    case 1: return 'HOTELS';
    case 2: return 'RENT-A-CAR';
    case 5: return 'FLIGHTS';
    case 6: return 'TOURS';
    case 8: return 'TRANSPORTS';
    case 9: return 'TOURS';
    case 10: return 'INSURANCE';
  }
}

/**
 * Método que establece el `searchId` en los resultados de búsqueda.
 *
 * Este método recibe un objeto `response` que contiene los resultados y un `searchId`.
 * Luego, agrega el `searchId` a cada uno de los resultados en el array `response.results`.
 *
 * @response -> Objeto que contiene los resultados de búsqueda y un `searchId` asociado.
 * @returns Ninguno. Modifica los resultados de búsqueda en su lugar.
 */
_setSearchIdInResults(response: any) {
  [ response.results ].forEach(obj => {
    obj.searchId = response.searchId;
  });
}

/**
 * Método para abrir el modal de carga.
 *
 * Este método abre un modal de carga utilizando el componente `ModalLoadingComponent`.
 * El modal se muestra con un ancho de 500px, el id "loadModal" y los datos del payload.
 *
 * @data -> datos del payload que se pasarán al modal.
 */
openModalLoading (data: any) {
  var dialogRef = this.dialog.open(ModalLoadingComponent, {
    width: '650px',
    id: "loadModal",
    data: data,
    disableClose: true
  });

  /* dialogRef.afterClosed().subscribe(result => {
  });*/
}

reloadEditPencilEmitter(): void {
  const payload = JSON.parse(localStorage.getItem('payload'));

  if(payload) {
    const categoryPayload = payload[0].categoriesId[0];
    if(categoryPayload) {
      const categoryNameOpenModal = this.categories.find(c => c.id === categoryPayload);
      if(categoryNameOpenModal) {
        this.openFormSearch(categoryNameOpenModal.label);
      }
    }
  }
}

setArrivalAndDeparture(response:any, payload:any){
  response.results.forEach(cars => {
    cars.dateIni = payload[0].arrivalDate;
    cars.dateEnd = payload[0].departureDate;
  });
}

onButtonHover(buttonIndex: number, isHovered: boolean): void {
  // No aplicar hover si el botón ya está activo
  if (this.activeButtonIndex === buttonIndex) return;

  // Aplicar el filtro correspondiente
  this.applyImageFilter(false, buttonIndex, isHovered);
  const iconElement = this.icons.toArray()[buttonIndex]?.nativeElement;

  // Cambiar estilo del botón (incluyendo Próximamente)
  const button = this.buttons.toArray()[buttonIndex]?.nativeElement;
  if (button) {
    const isComingSoon = this.activeComingSoonIndex === buttonIndex;
    const color = isHovered || isComingSoon
      ? this.styleSidebar?.background_color_header
      : this.styleSidebar?.color;

    // this.renderer.setStyle(button, 'color', color);
    const hoverFilter = this.getColorFilter(color);
    iconElement.style.filter = hoverFilter;
    iconElement.style.color = color;
  }
}

private setupButtonInteractions(): void {
  this.buttons.forEach((button, index) => {
    const mouseLeaveFn = () => {
      if (this.activeButtonIndex === index) return;

      this.applyImageFilter(false, index, false);
      // this.renderer.setStyle(button.nativeElement, 'border', 'none');
      this.renderer.setStyle(button.nativeElement, 'color', this.styleSidebar?.color);
      // this.renderer.setStyle(button.nativeElement, 'background-color', 'transparent');
      this.activeComingSoonIndex = null; // Resetear al salir
    };

    this.renderer.listen(button.nativeElement, 'mouseenter', () => {
      if (this.activeButtonIndex === index) return;

      this.applyImageFilter(true, index, false);
      // this.renderer.setStyle(button.nativeElement, 'border', `2px solid ${this.styleSidebar?.background_color_header}`);
      this.renderer.setStyle(button.nativeElement, 'color', `${this.styleSidebar?.background_color_header}`);
      // this.renderer.setStyle(button.nativeElement, 'background-color', 'white');

      // Mostrar "Próximamente" solo para índices > 3
      if(index === 5) {
        this.activeComingSoonIndex = index;
      }
    });

    this.renderer.listen(button.nativeElement, 'mouseleave', mouseLeaveFn);
  });
}

getSize(index: number) {

  if(index === 0 ||
     index === 1 ||
     index === 2 ||
     index === 3
  ) {
    return '19px';
  } else if(index === 4) {
    return '20px';
  } else if (
             index === 6
  ) {
    return '22px';
  } else if (index === 5) {
    return '16px';
  } else {
    return '20px';
  }
}

}
